import styled from 'styled-components'

export const Fields = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['16'],
}))
